import React from 'react';
import { Transition } from 'react-transition-group';

import {
  definedTransitions,
  DURATION,
  EASING,
  VERTICAL_OFFSET,
} from './constants';
import { TransitionStatus, TransitionChildren } from './types';
import { IAnimationProps, TComputedTransitions } from './types';

export const Animation: React.FC<IAnimationProps> = ({
  stackIndex = 0,
  children,
  transitions = [],
  duration = DURATION,
  easing = EASING,
  verticalOffset = VERTICAL_OFFSET,
  ...transitionProps
}) => (
  <Transition timeout={{ enter: 20, exit: duration }} {...transitionProps}>
    {(state: TransitionStatus): TransitionChildren => {
      const transitionList = definedTransitions(
        duration,
        easing,
        verticalOffset,
        stackIndex
      );

      const computedTransitions = transitions.reduce(
        (allTransitions, transition) => {
          allTransitions[transition] = {
            ...transitionList[transition].base,
            ...transitionList[transition].transition[state],
          };
          return allTransitions;
        },
        {}
      );

      return children(computedTransitions as TComputedTransitions);
    }}
  </Transition>
);
